import { OnboardingStep } from '../../OnboardingStep/OnboardingStep'
import { getStepStatus } from '../utils'

interface FavoriteChefStepProps {
  completed: boolean
  enabled: boolean
}

export function FavoriteChefStep({
  completed,
  enabled
}: Readonly<FavoriteChefStepProps>) {
  const handleSetPreferences = () => {
    // Pending logic implementation
  }

  return (
    <OnboardingStep
      title="Find Your Favorite Chefs"
      description="Set your taste profile and discover chefs who perfectly match your preferences."
      status={getStepStatus(completed, enabled)}
      icon="filters"
      action={{
        label: 'Set Up Profile',
        onClick: handleSetPreferences
      }}
    />
  )
}
